module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_7005.f52edd8e.png";